<template>
  <div>
    <breadcrumbs :crumbs="[{name:'Administrative Settings'},{name:'Email Settings', link:'Email Settings'}]"/>
    <div class="row">
      <div class="col-md-12">
        <div class="portlet light">
          <div class="portlet-title tabbable-line">
            <div class="caption caption-md">
              <i class="icon-settings font-dark"></i>
              <span class="caption-subject font-dark sbold uppercase">Email Settings</span>
            </div>

            <ul class="nav nav-tabs">
              <li
                v-for="tab in tabs"
                :key="tab.name"
                :class="{active: activeTab === tab.name}"
                @click="setActiveTab(tab.name)">
                <a
                  :href="`#${tab.name}`"
                  data-toggle="tab"
                  aria-expanded="false">
                  {{ tab.label}}
                </a>
              </li>
            </ul>
          </div>

          <div class="tab-content marginTop">
            <div
              v-for="tab in tabs"
              :key="tab.name"
              class="tab-pane"
              :class="{active: activeTab === tab.name}"
              :id="tab.name"
            >
              <component :is="tab.component"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import {mapGetters, mapActions} from "vuex";
import EmailTemplatesIndex from "../components/emails/TemplatesIndex"
import EmailHistoryIndex from "../components/emails/EmailHistoryIndex";
import EditEmail from "../components/emails/EditEmail";
import OrganizationEmailSettings from "../components/emails/OrganizationEmailSettings";

export default {
  components: {
    Breadcrumbs
  },

  data() {
    return {
      activeTab: null,
    }
  },

  computed: {
    ...mapGetters({
      appUser: 'getUser',
      emailMessage: 'emails/getEmail'
    }),
    tabs() {
      const userTab = {
        name: 'organization-email-settings',
        label: 'Organization settings',
        component: OrganizationEmailSettings,
      };

      const adminTabs = [{
        name: 'email-history',
        label: 'Email History',
        component: EmailHistoryIndex,
      }, {
        name: 'email-templates',
        label: 'Email Templates',
        component: EmailTemplatesIndex,
      }, {
        name: 'new-email',
        label: 'New Email',
        component: EditEmail,
      }]

      if (this.appUser.access > 5){
        return [userTab, ...adminTabs];
      } else {
        return [userTab];
      }
    }
  },

  mounted() {
    this.onRouteHashChange(this.$route.hash);
  },

  methods: {
    ...mapActions('emails',[
      'resetEmail'
    ]),
    setActiveTab(activeTabTitle) {
      this.activeTab = activeTabTitle;

      if(activeTabTitle === 'new-email' && this.emailMessage.id !== null) {
        this.resetEmail();
      }

      this.$router.push({name: 'Email Settings', hash: '#'+activeTabTitle});
    },
    onRouteHashChange(hash) {
      if(hash.length > 1) {
        this.setActiveTab(hash.substr(1));
      } else {
        if (this.appUser.access > 5) {
          this.$router.push({name: 'Email Settings', hash: '#email-history'});
        } else {
          this.$router.push({name: 'Email Settings', hash: '#organization-email-settings'});
        }
      }
    }
  },

  watch: {
    '$route.hash' : function(hash) {
      this.onRouteHashChange(hash);
    }
  },
}
</script>



// WEBPACK FOOTER //
// EmailSettings.vue?47af3381